import type { BridgeSource, BridgeType } from '../types/tooth.types'

interface ToothBaseVisibilityInput {
  missing: boolean
  implant: boolean
  bridge: BridgeType | undefined
  bridgeSource: BridgeSource | undefined
}

export const shouldHideToothBase = ({
  missing,
  implant,
  bridge,
  bridgeSource,
}: ToothBaseVisibilityInput): boolean => {
  const isBridgeType = typeof bridge === 'string' && bridge.endsWith('_bridge')

  // An abutment by itself keeps the natural tooth base visible. An implant or
  // missing tooth is structural and must take precedence regardless of the
  // order in which the conditions were applied.
  const preservesNaturalBase =
    bridgeSource === 'abutment' && !implant && !missing

  return !preservesNaturalBase && (missing || implant || isBridgeType)
}
